<template>
  <v-text-field outlined
                persistent-hint
                v-mask="['#####-###']"
                :hint="hintDescription"
                :label="label"
                v-model="localValue"
                :disabled="disabled"
                @blur="$emit('blur')"
                @change="onChangeCep"
                v-bind="$attrs"/>
</template>

<script>
import CepService from './cep-service';

const DEFAULT_HINT = 'Informe o CEP';
const CEP_LENGTH = 9;

export default {
  props: {
    value: String,
    initialMunicipio: Object,
    label: {
      type: String,
      default: 'CEP',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hintDescription: DEFAULT_HINT,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    onChangeCep() {
      this.$emit('change');

      if (!this.localValue || this.localValue.length !== CEP_LENGTH) {
        return;
      }
      const cep = this.localValue.match(/\d+/g)
        .join('');
      this.getCepData(cep);
    },
    formatDescription(endereco) {
      return `${endereco.municipio.nome} - ${endereco.estado.sigla}`;
    },
    formatDescriptionMunicipio(municipio) {
      return `${municipio.nome} - ${municipio.estado.sigla}`;
    },
    emitNewAddress(cidade) {
      this.$emit('cidadeloaded', cidade);
    },
    getCepData(cep) {
      this.$emit('loading', true);
      this.emitNewAddress(null);
      CepService.get(cep)
        .then(({ data }) => {
          if (data && data.municipio) {
            this.hintDescription = this.formatDescription(data);
            this.emitNewAddress(data.municipio);
            return;
          }
          this.emitNewAddress(null);
          this.hintDescription = DEFAULT_HINT;
        })
        .finally(() => {
          this.$emit('loading', false);
        });
    },
  },
  created() {
    if (this.initialMunicipio) {
      this.hintDescription = this.formatDescriptionMunicipio(this.initialMunicipio);
    }
  },
};
</script>
